/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMPasswordRecoveryBeginEvent } from '@/data/events/handlers/gtm/PasswordRecoveryBegin';
import { GTMPasswordRecoveryBeginPayload } from '@/data/types/GTM';

type PasswordRecoveryBeginDelegatorProps = {
	gtm?: GTMPasswordRecoveryBeginPayload;
};

export const passwordRecoveryBeginDelegator = async (
	payload: PasswordRecoveryBeginDelegatorProps
) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMPasswordRecoveryBeginEvent(gtm);
	}
};
